import { combineReducers } from "redux";
import { profile } from "./profileReducer";
import { notifications } from "./notifications";
import { discussions } from "./discussions";
import { users } from "./users/reducers";
import { discussionComments } from "./discussion-comments";
import { chats } from "./chats/reducers";
import { uiChatTab } from "./ui-chat-tab/reducers";
import { uiDiscussionPage } from "./ui-discussion-page";
import { uiDiscussionTab } from "./ui-discussion-tab";
import { discussionRecordings } from "./discussion-recordings";
import { appConfig } from "./appConfigReducer";

export const rootReducer = combineReducers({
    chats,
    profile,
    notifications,
    discussions,
    discussionComments,
    discussionRecordings,
    users,
    uiChatTab,
    uiDiscussionTab,
    uiDiscussionPage,
    appConfig,
});

export type ApplicationState = ReturnType<typeof rootReducer>;
